import Cookies from "universal-cookie";

import {
  postJsonRequest,
  getJsonRequest,
  patchJsonRequest,
  deleteJsonRequest,
} from "Helpers/ApiRequest";

function getCsrfToken() {
  const meta = document.querySelector("meta[name=csrf-token]");
  const token = meta && meta.getAttribute("content");

  return token ?? false;
}

const csrfToken = getCsrfToken();

const getVenueHeaders = (): Record<string, string> => {
  // The venueId is set in the app/Navigation/PageNavigation
  // Its less than ideal but it works for now.
  // In the future we could use a context provider to pass it down with hooks
  // Or maybe include it in the cookies

  const venueId = (window as any)?.venueUUID;
  if (!!venueId && typeof venueId == "string") {
    return {
      "X-Venue-UUID": venueId,
      "Client-ID": "venues_app",
    };
  } else {
    return {
      "Client-ID": "venues_app",
    };
  }
};
const getAuth = () => new Cookies().get("token");
export const authorizedGet = (params: any) =>
  getJsonRequest({
    ...params,
    headers: { ...getVenueHeaders(), Authorization: `Bearer ${getAuth()}` },
  });
export const authorizedPost = ({ url, body }: { url: string; body: any }) =>
  postJsonRequest({
    url,
    body,
    headers: { ...getVenueHeaders(), Authorization: `Bearer ${getAuth()}` },
  });
export const authorizedPatch = ({ url, body }: { url: string; body: any }) =>
  patchJsonRequest({
    url,
    body,
    headers: { ...getVenueHeaders(), Authorization: `Bearer ${getAuth()}` },
  });
export const authorizedDelete = ({ url, body }: { url: string; body?: any }) =>
  deleteJsonRequest({
    url,
    body,
    headers: { ...getVenueHeaders(), Authorization: `Bearer ${getAuth()}` },
  });
